import React from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation("common");
  const currentYear = new Date().getFullYear();
  return (
      <footer>
    {currentYear} | <Link to="/privacy_policy">{t("footerPrivacyPolicy")}</Link> |{" "}
          <Link to="/terms_of_use">{t("footerTermsOfUse")}</Link>  |{" "}
          <a href="mailto:support@fursatook.com" style={{textDecoration: 'none', color: 'inherit'}}>
              {t("footerContactSupport")}
          </a>
      </footer>
  );
}
